/**
 * RecoveryCodeList shows a set of recovery codes, once, as a numbered list a
 * person can copy or print. Codes are Latin letters and digits, so they keep
 * left-to-right order inside a Hebrew page.
 */
import { Stack } from '@rootsight/ui';

export function RecoveryCodeList({ codes }: { codes: string[] }) {
  return (
    <Stack as="ol" gap={1}>
      {codes.map((code) => (
        <li key={code}>
          <code className="rs-mono" dir="ltr">
            {code}
          </code>
        </li>
      ))}
    </Stack>
  );
}
